import store from "../../../../../../store";
import universalCanvasManager from "./UniversalCanvasManager";
import {activateCanvasTool} from "../../../../../../actions/sqftResourceFunctions";

export const activateCanvasToolDirect = (tool, feature, settings = {}) => {
  universalCanvasManager.activateToolDirect(tool, feature, settings);
};

export const deactivateCanvasToolDirect = () => {
  universalCanvasManager.deactivateToolDirect();
};

export const initCanvasManager = () => {
  universalCanvasManager.init();
};

export const shutdownCanvasManager = () => {
  universalCanvasManager.shutdown();
};

// Specific tool activators
export const activateEdgeTool = (edgeFeature, fromWizardGroupId = null, disallowDemo = false) => {
  store.dispatch(activateCanvasTool('edge', edgeFeature, { fromWizardGroupId, disallowDemo }));
  activateCanvasToolDirect('edge', edgeFeature, { fromWizardGroupId, disallowDemo });
}

export const activateBacksplashTool = (size, name, disallowDemo = false) => {
  store.dispatch(activateCanvasTool('backsplash', { size, name }, { disallowDemo }));
  activateCanvasToolDirect('backsplash', { size, name }, { disallowDemo });
}

export const activateBumpoutTool = (disallowDemo = false) => {
  store.dispatch(activateCanvasTool('bumpout', {}, { disallowDemo }));
  activateCanvasToolDirect('bumpout', { }, { disallowDemo });
}

export const activateCrownMoldingTool = (feature = null, disallowDemo = false) => {
  store.dispatch(activateCanvasTool('crown_molding', feature || {}, { disallowDemo }));
  activateCanvasToolDirect('crown_molding', feature || {}, { disallowDemo });
}

export const activateEndCapTool = (feature = null, disallowDemo = false) => {
  store.dispatch(activateCanvasTool('end_cap', feature || {}, { disallowDemo }));
  activateCanvasToolDirect('end_cap', feature || {}, { disallowDemo });
}
